module.exports = __webpack_public_path__ + "static/img/automation.9cc61b90.png";